import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import cardAndHandImg from '../../assets/images/card-and-hand.png';
import {
  CARD_POSITION_INITIAL,
  CARD_POSITION_READ,
  CARD_POSITION_READ_FINISHED,
} from './constants';
import {
  TABLET_BREAKPOINT_IN_PX,
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_SIZE_IN_PERCENTAGE,
  MOBILE_SIZE_IN_PERCENTAGE,
} from '../../constants';

const CARD_HEIGHT_IN_PX = 381;
const CARD_WIDTH_IN_PX = 277;

// prettier-ignore
const CardAndHandImage = styled.img`
  height: ${CARD_HEIGHT_IN_PX}px;
  width: ${CARD_WIDTH_IN_PX}px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    height: ${CARD_HEIGHT_IN_PX * TABLET_SIZE_IN_PERCENTAGE}px;
    width: ${CARD_WIDTH_IN_PX * TABLET_SIZE_IN_PERCENTAGE}px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    height: ${CARD_HEIGHT_IN_PX * MOBILE_SIZE_IN_PERCENTAGE}px;
    width: ${CARD_WIDTH_IN_PX * MOBILE_SIZE_IN_PERCENTAGE}px;
  }

  ${(props) => props.isFullScreenModeEnabled && css`
    @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
      height: ${CARD_HEIGHT_IN_PX}px;
      width: ${CARD_WIDTH_IN_PX}px;
    }
  `};
`;

const getCardTransformStyle = (position, isMobile) => {
  if (position === CARD_POSITION_INITIAL) {
    if (isMobile) {
      return {
        opacity: 0,
        transform: 'scale(1.5) rotate(-20deg) translateY(80%)',
      };
    }
    return {
      transform: 'scale(1)',
      transition: 'transform 1.25s ease-in-out',
    };
  }
  if (position === CARD_POSITION_READ) {
    return {
      transform: 'scale(0.85) translateY(5%) translateX(-50%)',
      transition: 'transform 0.5s 0.25s',
    };
  }
  if (position === CARD_POSITION_READ_FINISHED) {
    return {
      transform: 'scale(1) rotate(4deg) translateY(1%) translateX(15%)',
      transition: 'transform 0.75s ease-in-out',
    };
  }
  return {
    transform: 'scale(1.5) rotate(-20deg) translateY(80%)',
    transition: 'transform 0.5s ease-in-out',
  };
};

const CardAndHand = ({ position, isFullScreenModeEnabled }) => {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT_IN_PX;
  const cardTransformStyle = getCardTransformStyle(position, isMobile);
  return (
    <CardAndHandImage
      style={cardTransformStyle}
      src={cardAndHandImg}
      isFullScreenModeEnabled={isFullScreenModeEnabled}
    />
  );
};

CardAndHand.propTypes = {
  position: PropTypes.number.isRequired,
  isFullScreenModeEnabled: PropTypes.bool.isRequired,
};

export default CardAndHand;
